import React from "react";
import PropTypes from "prop-types";

import StatProgress from "./stat-progress";
import StatNumber from "./stat-number";
import StatText from "./stat-text";

function Stat(props) {
	const { type } = props;

	if (type === "progress-bar") {
		return (<StatProgress {...props} />);
	} else if(type === "number") {
		return (<StatNumber {...props} />)
	} else if(type === "text") {
		return (<StatText {...props} />)
	}
}

Stat.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	isLast: PropTypes.bool,
	color: PropTypes.string,
	currentValue: PropTypes.number,
	maxValue: PropTypes.number,

	onClick: PropTypes.func
};

export default Stat;
